var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useMemo, useRef } from 'react';
import { Glyph, glyphNames } from '@cb/apricot-react-glyph';
import { Icon, iconNames } from '@cb/apricot-react-icon';
import cn from 'classnames';
const ToggleButtonContext = React.createContext({
    name: '',
    onChange: () => { },
    defaultValue: '',
    groupValue: '',
});
export const ToggleButtonGroup = ({ toggleButtonId, name, className, children, onChange, defaultValue, groupValue, ariaLabel, ariaLabelledbyID, }) => {
    const context = useMemo(() => ({ name, onChange, defaultValue, groupValue }), [name, onChange, defaultValue, groupValue]);
    return (React.createElement("div", { className: cn('cb-toggles-btn', className), id: toggleButtonId, role: "radiogroup", "aria-label": ariaLabel && ariaLabel, "aria-labelledby": ariaLabelledbyID && ariaLabelledbyID, "data-cbtrack-comp": "apricot-react:toggles-btn" },
        React.createElement(ToggleButtonContext.Provider, { value: context }, children)));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIcon = (x) => iconNames.includes(x);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isGlyph = (x) => glyphNames.includes(x);
export const ToggleButton = (_a) => {
    var { buttonId, labelId, value, ariaLabel, icon, children, disabled = false } = _a, props = __rest(_a, ["buttonId", "labelId", "value", "ariaLabel", "icon", "children", "disabled"]);
    const radioRef = useRef(null);
    const context = useContext(ToggleButtonContext);
    return (React.createElement("label", { htmlFor: buttonId, id: labelId },
        React.createElement("input", Object.assign({ ref: radioRef, id: buttonId, type: "radio", name: context.name, value: value, defaultChecked: value === context.defaultValue, checked: context.groupValue ? value === context.groupValue : undefined, disabled: disabled, onChange: e => context.onChange(e.target.value), "aria-label": ariaLabel }, props)),
        React.createElement("span", null, icon ? null : children),
        icon && isIcon(icon) && React.createElement(Icon, { name: icon, decorative: true }),
        icon && !isIcon(icon) && isGlyph(icon) && React.createElement(Glyph, { name: icon, decorative: true })));
};
//# sourceMappingURL=ToggleButton.js.map